import { render, staticRenderFns } from "./ProductSingleOptions.vue?vue&type=template&id=0b7f4af5&"
import script from "./ProductSingleOptions.vue?vue&type=script&lang=js&"
export * from "./ProductSingleOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports